import { RegionalAirportConfig } from "@/components/RegionalLayout";
import { RegionalVuelosConfig } from "@/components/RegionalVuelos";

export const mpdaVuelosConfig: RegionalVuelosConfig = {
  airport: "dav",
  airportCode: "MPDA",
  basePath: "/mpda/vuelos",
  backPath: "/mpda",
};

export const mpdaConfig: RegionalAirportConfig = {
  code: "MPDA",
  name: {
    es: "Aeropuerto Internacional Enrique Malek",
    en: "Enrique Malek International Airport",
  },
  basePath: "/mpda",
  navLinks: [
    {
      label: { es: "Inicio", en: "Home" },
      href: "/mpda",
    },
    {
      label: { es: "Vuelos", en: "Flights" },
      href: "/mpda/vuelos",
    },
    {
      label: { es: "Pasajeros", en: "Passengers" },
      href: "/mpda/pasajeros",
    },
    {
      label: { es: "Aeropuertos", en: "Airports" },
      href: "/aeropuertos",
    },
    {
      label: { es: "Contacto", en: "Contact" },
      href: "/mpda/mantenimiento",
    },
  ],
  contact: {
    phone: "+(507) 316-3777",
    email: "info@tocumenpanama.aero",
    address: {
      es: "David, Provincia de Chiriquí, Panamá",
      en: "David, Chiriquí Province, Panama",
    },
  },
  socialLinks: {
    facebook: "https://facebook.com/tocumenairport",
    instagram: "https://instagram.com/tocumenairport",
    twitter: "https://twitter.com/tocumenairport",
  },
};
